/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PriceSignal } from './PriceSignal';
import {
    PriceSignalFromJSON,
    PriceSignalFromJSONTyped,
    PriceSignalToJSON,
    PriceSignalToJSONTyped,
} from './PriceSignal';
import type { PriceHistoryPoint } from './PriceHistoryPoint';
import {
    PriceHistoryPointFromJSON,
    PriceHistoryPointFromJSONTyped,
    PriceHistoryPointToJSON,
    PriceHistoryPointToJSONTyped,
} from './PriceHistoryPoint';

/**
 * 
 * @export
 * @interface PricePredictionResult
 */
export interface PricePredictionResult {
    /**
     * 
     * @type {number}
     * @memberof PricePredictionResult
     */
    confidenceScore: number;
    /**
     * 
     * @type {string}
     * @memberof PricePredictionResult
     */
    label: string;
    /**
     * 
     * @type {Array<PriceSignal>}
     * @memberof PricePredictionResult
     */
    signals: Array<PriceSignal>;
    /**
     * 
     * @type {Array<PriceHistoryPoint>}
     * @memberof PricePredictionResult
     */
    priceHistory: Array<PriceHistoryPoint>;
    /**
     * 
     * @type {number}
     * @memberof PricePredictionResult
     */
    observationsCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof PricePredictionResult
     */
    hasSufficientData: boolean;
}

/**
 * Check if a given object implements the PricePredictionResult interface.
 */
export function instanceOfPricePredictionResult(value: object): value is PricePredictionResult {
    if (!('confidenceScore' in value) || value['confidenceScore'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('signals' in value) || value['signals'] === undefined) return false;
    if (!('priceHistory' in value) || value['priceHistory'] === undefined) return false;
    if (!('observationsCount' in value) || value['observationsCount'] === undefined) return false;
    if (!('hasSufficientData' in value) || value['hasSufficientData'] === undefined) return false;
    return true;
}

export function PricePredictionResultFromJSON(json: any): PricePredictionResult {
    return PricePredictionResultFromJSONTyped(json, false);
}

export function PricePredictionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricePredictionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'confidenceScore': json['confidence_score'],
        'label': json['label'],
        'signals': ((json['signals'] as Array<any>).map(PriceSignalFromJSON)),
        'priceHistory': ((json['price_history'] as Array<any>).map(PriceHistoryPointFromJSON)),
        'observationsCount': json['observations_count'],
        'hasSufficientData': json['has_sufficient_data'],
    };
}

export function PricePredictionResultToJSON(json: any): PricePredictionResult {
    return PricePredictionResultToJSONTyped(json, false);
}

export function PricePredictionResultToJSONTyped(value?: PricePredictionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confidence_score': value['confidenceScore'],
        'label': value['label'],
        'signals': ((value['signals'] as Array<any>).map(PriceSignalToJSON)),
        'price_history': ((value['priceHistory'] as Array<any>).map(PriceHistoryPointToJSON)),
        'observations_count': value['observationsCount'],
        'has_sufficient_data': value['hasSufficientData'],
    };
}

